import React from 'react';
import { Box, BodyText, Link } from 'src/viewLayer/components/DesignSystem';

import { LOCALE } from 'src/dataLayer/env';
import { t } from 'src/viewLayer/helpers/translations';
import { getGdprOptions } from './getGdprOptions';
import TextWithPartialCustomStyling from 'src/viewLayer/components/shared/TextWithPartialCustomStyling';
import type { LinkProps, PrivacyProps } from './types';
import './index.scss';

const TermsLink: React.FC<LinkProps> = ({ children }): JSX.Element =>
  <span className="TermsLink">
    <Link
      href={`https://about.babbel.com/${LOCALE}/terms`}
      rel="noreferrer"
      size="small"
      target="_blank"
      weight="strong"
    >
      {children}
    </Link></span>
  ;

const PrivacyLink: React.FC<LinkProps> = ({ children }): JSX.Element =>
  <span className="PrivacyLink">
    <Link
      href={`https://about.babbel.com/${LOCALE}/privacy`}
      rel="noreferrer"
      size="small"
      target="_blank"
      weight="strong"
    >
      {children}
    </Link>
  </span>;

export const Privacy = ({ scrollToRef }: PrivacyProps): JSX.Element => {
  const isGdprCountry = getGdprOptions();

  const translation = isGdprCountry ?
    t('registration.partials.privacy.privacy_and_terms_and_gdpr_bundled_interpolated') :
    t('registration.partials.privacy.privacy_and_terms_bundled_interpolated');

  return (
    <Box padding={[0, 12]}>
      <BodyText
        ref={scrollToRef}
        className="PrivacySection"
        size="small"
      >
        {
          TextWithPartialCustomStyling({
            translationText: translation,
            customStyledComponents: [TermsLink, PrivacyLink]
          }).map((TextPiece: JSX.Element) => TextPiece)
        }
      </BodyText>
    </Box>
  );
};
